import React, { useState, ReactNode, FC } from 'react'
import { TabPaneProps } from './TabPane'
import styles from './Tabs.module.scss'
import classNames from 'classnames'

type TabsProps = {
  children: ReactNode
  isOtherContentHidden?: boolean
}

const Tabs: FC<TabsProps> = ({ children, isOtherContentHidden = false }) => {
  const [activeIndex, setActiveIndex] = useState(0)

  const handleTabClick = (index: number) => {
    setActiveIndex(index)
  }

  // Get all Tab components
  const tabs = React.Children.toArray(children)

  return (
    <div className={styles.tabsWrapper}>
      <div className={styles.tabsContainer}>
        {tabs.map((tab, index) => (
          <h5
            id={
              (tab as React.ReactElement<TabPaneProps>).props.id ??
              (tab as React.ReactElement<TabPaneProps>).props.label
            }
            key={index}
            className={classNames(styles.tabsButton, {
              [styles.tabsButtonActive]: activeIndex === index,
            })}
            onClick={() => handleTabClick(index)}
          >
            {(tab as React.ReactElement<TabPaneProps>).props.label}
          </h5>
        ))}
        <hr />
      </div>
      {isOtherContentHidden ? (
        <div className={styles.tabsContentContainer}>
          {tabs.map((tab, index) => (
            <div
              key={index}
              className={classNames(styles.tabsContentBox, {
                [styles.tabsContentBoxVisible]: activeIndex === index,
              })}
            >
              {(tab as React.ReactElement<TabPaneProps>).props.children}
            </div>
          ))}
        </div>
      ) : (
        (tabs[activeIndex] as React.ReactElement<TabPaneProps>).props.children
      )}
    </div>
  )
}

export default Tabs
